import { useEffect, useState } from 'react'
import { IPaths, PathsEventEnum } from '../../model/naglog/IPaths'
import '../styles.css'
import { IPath } from '../../model/ahamove/UrlRequestParam'
import TableEditable from '../../experiment/table/table-editable/TableEditable'
import { NEW_PRODUCT, PRODUCT_COLUMNS_WITH_ACTION } from '../../experiment/data/fake-data/NaglogData'
import { IProduct } from '../../model/wms/IProduct'

export default function PathsComponent(props: IPaths) {

  const [data, setData] = useState<IPath[]>(props.data_source)
  const [isProductChange, setIsProductChange] = useState<boolean>(false)
  useEffect(() => {
    // cha thay đổi thì con cũng cập nhật cần có flag để xác định cha thay đổi
    if (isProductChange) {
      let products = handleMergeProducts(data)
      props.updatePath(products, PathsEventEnum.ITEMS)
      setIsProductChange(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProductChange])



  const handleSaveProducts = (products: any, optional: any) => {
    let index = optional.index
    // let dataOrigin = [...data]
    data[index].items = products
    setData(data)
    setIsProductChange(true)

  }
  const handleMergeProducts = (dataPaths: IPath[]): IProduct[] => {
    const mergedProducts: IProduct[] = [];
    dataPaths.forEach((path) => {
      path.items?.forEach((product) => {
        const existingProduct = mergedProducts.find((p) => p.ma === product.ma);
        if (existingProduct) {
          // Nếu sản phẩm đã tồn tại, cộng các trường
          existingProduct.soLuong += Number.parseFloat(product.soLuong.toString())
          existingProduct.theTich += Number.parseFloat(product.theTich.toString())
          existingProduct.trongLuong += Number.parseFloat(product.trongLuong.toString())
        } else {
          // Nếu sản phẩm chưa tồn tại, thêm vào danh sách tránh null
          let inputs = {
            soLuong: Number.parseFloat(product.soLuong.toString()) ?? 0,
            theTich: Number.parseFloat(product.theTich.toString()) ?? 0,
            trongLuong: Number.parseFloat(product.trongLuong.toString()) ?? 0
          }
          product = { ...product, ...inputs }
          mergedProducts.push({ ...product });
        }
      });
    });
    return mergedProducts;
  }

  const dataPathTmp = () => {
    return data.map((element, index) => {
      // sender
      if (index === 0) {
        let senderTmp = (
          <div key={index}>
            <div className='row align-items-center'>
              <label className='text-nowrap col-2'>sender name:</label>
              <div className='p-1 col-auto'><input type='text' id='sender-name-id' name='sender-name-name' value={element.sender_name} attr-props='sender_name' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} /></div>
              <label className='text-nowrap col-2'>sender mobile:</label>
              <div className='p-1 col-auto'><input type='text' id='sender-mobile-id' name='sender-mobile-name' value={element.sender_mobile} attr-props='sender_mobile' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} /></div>
            </div>
            <div className='row align-items-center'>
              <label className='text-nowrap col-2'>sender address:</label>
              <div className='p-1 col'><input type='text' className='w-75' id='sender-address-id' name='sender-address-name' value={element.address} attr-props='sender_address' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} /></div>
            </div>
            <hr />
          </div>
        )
        return senderTmp
      } else {
        let products = element.items ?? []
        let receiverTmp = (
          <div key={index}>
            <div className='row' id={`box-${index}`}>
              {/* box input */}
              <div className='col-8'>
                <div className='row align-items-center'>
                  <label className='text-nowrap col-3'>receiver name:</label>
                  <div className='p-1 col-auto'>
                    <input type='text' id={`receiver-name-${index}-id`} name={`text-receiver-${index}-name`} value={element.name} attr-props='name' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} />
                  </div>
                  <label className='text-nowrap col-3'>receiver mobile:</label>
                  <div className='p-1 col-auto'>
                    <input type='text' id={`receiver-mobile-${index}-id`} name={`text-receiver-${index}-name`} value={element.mobile} attr-props='mobile' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} />
                  </div>
                </div>
                <div className='row align-items-center'>
                  <label className='text-nowrap col-3'>receiver address:</label>
                  <div className='p-1 col'>
                    <input type='text' className='w-75' id={`receiver-address-${index}-id`} name={`receiver-address-${index}-name`} value={element.address} attr-props='address' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} />
                  </div>
                </div>

                <div className='row align-items-center'>
                  <label className='text-nowrap col-3'>tracking number:</label>
                  <div className='p-1 col-auto'>
                    <input type='text' id={`tracking-number-${index}-id`} name={`tracking-number-${index}-name`} value={element.tracking_number} attr-props='tracking_number' onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} />
                  </div>
                </div>
                <div className='row align-items-center'>
                  <label className='text-nowrap col-3'>remarks:</label>
                  <div className='p-1 col-auto'>
                    <textarea id={`remarks-${index}-id`} name={`remarks-${index}-name`} value={element.remarks} rows={2} cols={50} onChange={(e) => props.updatePath(e, PathsEventEnum.CHANGE, index)} attr-props='remarks' />
                  </div>
                </div>

              </div>
              {/* box action */}
              <div className='col-auto'>
                <button id={`remove-receiver-${index}`} type='button' onClick={(e) => props.updatePath(e, PathsEventEnum.REMOVE, index)}>remove</button>
              </div>
            </div>

            {/* products data */}
            <div className='row'>
              <div className='col py-0'>
                <TableEditable id={`path-products-${index}-id`} columns={PRODUCT_COLUMNS_WITH_ACTION} fetchData={products} newRow={NEW_PRODUCT} handleSave={handleSaveProducts} param={{ index: index }} />
              </div>
            </div>
            <hr />
          </div>
        )
        return receiverTmp
      }
    })
  }


  return (
    <div>
      {dataPathTmp()}
    </div>
  )
}
